/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { changeAlbumCollectionItemNumberModelSchema } from "../changeAlbumCollectionItemNumberModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const putApiAlbumCollectionsIdAlbumsOrderPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор выпуска")
    })

/**
 * @description Порядок альбомов изменен
 */
export const putApiAlbumCollectionsIdAlbumsOrder200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации | Число переданных альбомов не совпадает с числом существующих
 */
export const putApiAlbumCollectionsIdAlbumsOrder400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiAlbumCollectionsIdAlbumsOrder401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiAlbumCollectionsIdAlbumsOrder403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Выпуск не найден | Альбом не найден
 */
export const putApiAlbumCollectionsIdAlbumsOrder404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiAlbumCollectionsIdAlbumsOrder500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiAlbumCollectionsIdAlbumsOrderMutationRequestSchema = z.array(z.lazy(() => changeAlbumCollectionItemNumberModelSchema)).describe("Тело запроса")

export const putApiAlbumCollectionsIdAlbumsOrderMutationResponseSchema = z.lazy(() => putApiAlbumCollectionsIdAlbumsOrder200Schema)